import type React from 'react';
import styled from 'styled-components';

type OwnProps = React.SVGProps<SVGSVGElement>;

const SvgIcon = ({ children, className, viewBox, ...props }: OwnProps) => (
  <svg
    className={className}
    viewBox={viewBox}
    {...props}
    focusable="false"
    aria-hidden="true"
  >
    {children}
  </svg>
);

SvgIcon.defaultProps = {
  viewBox: '0 0 24 24',
  width: '1em',
  height: '1em',
  fontSize: '1.5rem'
};

const StyledSvgIcon: React.ComponentType<OwnProps> = styled(SvgIcon)`
  display: inline-block;
  fill: ${({ currentColor }) => currentColor};
  flex-shrink: 0;
  font-size: ${({ fontSize }) => fontSize};
  height: ${({ height }) => height};
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  user-select: none;
  width: ${({ width }) => width};
`;

export default StyledSvgIcon;
